export enum AdType {
    Fuel = 1,
    Tech5G = 2,
    FilesDDD = 3,
    Serwis = 4,
    NewOrders = 5,
    VehicelesAfter2025 = 6,
    End2gNew5g = 7,
    Tech5gBussiness = 8,
    DriverLicense = 9,
}
